(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(() => {
  const media = window.matchMedia('(max-width:1199px)');
  const placeSwitcher = () => {
    const switcher = document.getElementById('cvc-switcher-manual-desktop');
    const mobileSlot = document.getElementById('dg-mobile-localization');
    const desktopSlot = document.querySelector('store-header .header__secondary-links > .header__icon-list');
    const destination = media.matches ? mobileSlot : desktopSlot;
    if (switcher && destination && switcher.parentElement !== destination) destination.prepend(switcher);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', placeSwitcher, {once:true});
  else placeSwitcher();
  media.addEventListener('change', placeSwitcher);
  document.addEventListener('shopify:section:load', placeSwitcher);
})();

  } catch(e) { console.error(e); }
})();
})();
